// ═══════════════════════════════════════
// INSTRUMENT-CONTEXT
// Source de vérité sur les instruments actifs.
// Les modules s'abonnent via onInstrumentsChange()
// pour réagir aux changements de sélection.
// ═══════════════════════════════════════

let _currentInstruments = [];
const _listeners = [];

// Appelé par header-form.js à chaque changement d'instruments
export function setActiveInstruments(instruments) {
    _currentInstruments = instruments;
    _listeners.forEach(fn => fn(instruments));
}

// Retourne les instruments actifs courants
export function getActiveInstruments() {
    return _currentInstruments;
}

// Retourne true si un instrument avec ce name est actif
export function hasInstrument(name) {
    return _currentInstruments.some(i => i.name === name);
}

// Abonne une fonction au changement d'instruments.
// La callback reçoit le tableau d'instruments actifs.
export function onInstrumentsChange(fn) {
    _listeners.push(fn);
}